export class TrailEvent {
    constructor(model) {
        this.id = model.id;
        this.projectId = model.projectId;
        this.type = model.type;
        this.createdAt = new Date(model.createdAt);
        this.updatedAt = model.updatedAt ? new Date(model.updatedAt) : undefined;
        this.userId = model.userId;
        this.payload = model.payload;
    }
    toRemote() {
        return this;
    }
}
